/* src/app/company-calendar/company-calendar-presenter/company-calendar-presenter.component.scss */
body#themeTag :host ::ng-deep .fc-toolbar.fc-header-toolbar {
  margin-bottom: 0 !important;
}
body#themeTag :host ::ng-deep .display-colorpicker {
  font-size: 10.5px;
}
body#themeTag :host ::ng-deep .display-colorpicker .p-colorpicker.p-component.p-colorpicker-overlay {
  width: 100%;
}
body#themeTag :host ::ng-deep .dialog-colorpicker .p-colorpicker-preview.p-inputtext {
  width: 100% !important;
}
body#themeTag :host ::ng-deep .multi-colorpicker .p-colorpicker-preview.p-inputtext {
  width: 8em !important;
}
body#themeTag :host ::ng-deep .p-datatable-scrollable-body {
  margin-top: 0.8em;
}
/*# sourceMappingURL=company-calendar-presenter.component.css.map */
